import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoBanner from "../../assets/images/new_logo_without_font.png";
import HighPerformanceAd from "../../components/HighPerformanceAd";
import optionsImage from "../../assets/images/why_be_trader.png";

export default function BlogWelcome() {

  useEffect(() => {
    document.title = "Welcome | CoinzUp";
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-x-hidden">
    <header className="border-b border-gray-800 px-4 sm:px-6 py-4 flex items-center justify-between">
      <Link to="/index">
        <img src={logoBanner} alt="CoinZUp Logo" className="w-32 sm:w-40 h-auto" />
      </Link>
      <div className="space-x-3 sm:space-x-4 text-sm sm:text-base"> 
        <Link to="/blog" className="hover:underline">Blog</Link>
        <Link to="/login" className="hover:underline">Log In</Link>
        <Link to="/register" className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition">Sign Up</Link>
      </div>
    </header>
          {/* 🄸🄵🅁🄰🄼🄴 🔽 always visible and responsive */}
    <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90}/>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-yellow-400 mb-6">
           Welcome to the Official CoinzUp Blog!
        </h1>
        <p className="text-gray-300 mb-4 text-lg">
          We're excited to launch the CoinzUp Blog — your go-to hub for tips, updates,
          and everything happening on our platform.
        </p>
        <ul className="list-disc list-inside text-gray-300 mb-6">
          <li> Earn Coinz every single day</li>
          <li> Trade virtual options</li>
          <li> Use autosurf to earn passively</li>
          <li> Get dividends from virtual shares</li>
          <li> Join free hourly draws</li>
        </ul>
        <p className="text-gray-400 mb-4">
          This blog will keep you in the loop about all major updates, share powerful
          earning tips, and help you understand crypto even if you’re just starting out.
        </p>
        <p className="text-gray-500 text-sm italic">
          Article published on May 16, 2025 — CoinzUp
        </p>
      </div>

      <HighPerformanceAd keyId="96e99453a24be0353f2fe26dc0b9b728" width={468} height={60}/>
    </div>
    
  );
}
